export const companyInfo = {
  name: "Bierz",
  tagline: "Distribuidora de Chopp e Cervejas Especiais",
  description: "A Bierz é uma distribuidora de Chopp e cervejas especiais voltada para a região de Sorocaba. Trabalhamos com as melhores marcas do mercado para garantir a qualidade e satisfação dos nossos clientes.",
  address: "Rua Professor Toledo, 665, Centro - Sorocaba/SP",
  phone: "(15) 99147-4614",
  whatsapp: "5515991474614",
  email: "bierz665@gmail.com",
  instagramHandle: "@bieerz",
  instagramUrl: "https://www.instagram.com/bieerz/",
  hours: "Atendimento 24 horas"
};
